import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';
import { printDocs } from '../utils/printDocs';

export default function MyDocsPage() {
  const [docs, setDocs] = useState([]);
  const [title, setTitle] = useState('');
  const [busy, setBusy] = useState(false);
  const [checked, setChecked] = useState({});
  const [editId, setEditId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const fileRef = useRef();

  const load = () => api.get('/my-docs').then(r => setDocs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const uploadFiles = async files => {
    if (!files.length) return;
    const fd = new FormData();
    fd.append('title', title);
    [...files].forEach(f => fd.append('files', f));
    setBusy(true);
    try { await api.post('/my-docs', fd); load(); }
    catch (e) { alert(e.response?.data?.error || 'Не удалось загрузить'); }
    setBusy(false);
    if (fileRef.current) fileRef.current.value = '';
  };
  const remove = async d => {
    if (!window.confirm(`Удалить «${d.title}»?`)) return;
    await api.delete(`/my-docs/${d.id}`); load();
  };
  const saveTitle = async () => { await api.put(`/my-docs/${editId}`, { title: editTitle }); setEditId(null); load(); };

  const selected = docs.filter(d => checked[d.id]);

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <h1 className="page-title">Мои документы</h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn btn-primary" disabled={!selected.length} onClick={() => printDocs(selected)}>🖨 Печать выбранных{selected.length ? ` (${selected.length})` : ''}</button>
          <button className="btn btn-secondary" disabled={!docs.length} onClick={() => printDocs(docs)}>🖨 Печать всех</button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="form-row" style={{ alignItems: 'flex-end' }}>
          <div className="form-group"><label>Название</label><input className="form-input" value={title} onChange={e => setTitle(e.target.value)} placeholder="Паспорт, разворот 2–3" /></div>
          <div className="form-group"><label>Файлы (фото, PDF, аудио — можно несколько; без названия возьмётся имя файла)</label>
            <input ref={fileRef} type="file" className="form-input" multiple accept=".jpg,.jpeg,.png,.webp,.heic,.pdf,.mp3,.m4a,.ogg,.oga,.opus,.wav,.aac,.amr,.webm,audio/*" disabled={busy} onChange={e => uploadFiles(e.target.files)} /></div>
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Картинки печатаются по две на лист A4 (например, разворот с фото и прописка), PDF — как есть. Файлы видны только после входа в CRM.</div>
      </div>

      {!docs.length && <div className="empty-state"><p>Пока пусто — загрузите скан или фото паспорта</p></div>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
        {docs.map(d => (
          <div key={d.id} className="card" style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
              <input type="checkbox" checked={!!checked[d.id]} onChange={e => setChecked(c => ({ ...c, [d.id]: e.target.checked }))} />
              {editId === d.id
                ? <input className="form-input" value={editTitle} autoFocus onChange={e => setEditTitle(e.target.value)} onKeyDown={e => e.key === 'Enter' && saveTitle()} onBlur={saveTitle} onClick={e => e.preventDefault()} />
                : <strong style={{ fontSize: 14 }}>{d.title}</strong>}
            </label>
            <a href={`/api/my-docs/${d.id}/file`} target="_blank" rel="noreferrer" style={{ display: 'block', background: 'var(--bg-surface)', borderRadius: 6, height: 150, overflow: 'hidden' }}>
              {/^image\//.test(d.mimetype)
                ? <img src={`/api/my-docs/${d.id}/file`} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>{/^audio\//.test(d.mimetype) ? '🎙️' : '📄'}<span style={{ fontSize: 13, marginLeft: 6 }}>{/^audio\//.test(d.mimetype) ? 'Аудио' : 'PDF'}</span></div>}
            </a>
            <div style={{ display: 'flex', gap: 6 }}>
              <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={() => printDocs([d])}>🖨 Печать</button>
              <button className="btn btn-secondary btn-sm" onClick={() => { setEditId(d.id); setEditTitle(d.title); }}>✎</button>
              <button className="btn btn-secondary btn-sm" onClick={() => remove(d)}>🗑</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
